import ApopheniaLogger from "apophenia-javascript-logger";

(() => {
  const hopeButton = document.getElementById("hopeCtaButton");

  if (!window.REFERRALS || !hopeButton) {
    return;
  }

  const Logger = ApopheniaLogger.initialize({
    appId: "elp.dr-smartvestor",
    apiKey: window.REFERRALS.apopheniaKey,
  });

  hopeButton.addEventListener("click", function (e) {
    e.preventDefault();

    Logger.send("link.click.success", {
      referral_key: e.target.dataset.svRfid,
      message: "hope_cta_click",
      lead_type: "investment",
    }, () => {
      window.location = e.target.href;
    });
  });
})();
